import { render, staticRenderFns } from "./ImgSwiperV7.vue?vue&type=template&id=cb76af08&scoped=true&"
import script from "./ImgSwiperV7.vue?vue&type=script&lang=js&"
export * from "./ImgSwiperV7.vue?vue&type=script&lang=js&"
import style0 from "./ImgSwiperV7.vue?vue&type=style&index=0&id=cb76af08&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb76af08",
  null
  
)

export default component.exports